import { IDonHangActions } from "../../action-types/don-hang/IDonHangActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDonHangReducer } from "../../reducer-model/don-hang/IDonHangReducer";

const iniState: IDonHangReducer = {
    status: eReducerStatusBase.is_not_initialization,
    donHangs: [],
    donHangSelectedIds: [],
    trangThaiSelectedIds: []
};

export const donHangReducer = (state: IDonHangReducer = iniState, action: IDonHangActions): IDonHangReducer => {
    switch (action.type) {
        case "DON_HANG_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "DON_HANG_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                donHangs: action.payload
            };
        case "DON_HANG_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "DON_HANG_CHANGED_DONHANG_SELECTED_IDS":
            return {
                ...state,
                donHangSelectedIds: action.payload
            };
        case "DON_HANG_CHANGED_TRANGTHAI_SELECTED_IDS":
            return {
                ...state,
                trangThaiSelectedIds: action.payload
            };
        default:
            return state;
    }
};
